import { Spin } from "antd";
import type { SpinProps } from "antd";
import { ReactNode } from "react";

interface CommonSpinProps extends SpinProps {
  loading?: boolean;
  children?: ReactNode;
}

export const CommonSpin = ({ loading = true, size = "default", fullscreen, children, ...props }: CommonSpinProps) => {
  return (
    <Spin spinning={loading} size={size} fullscreen={fullscreen} {...props}>
      {children}
    </Spin>
  );
};
